/**
 * Common regex patterns used across validation
 */

// Basic text patterns
export const TEXT_ONLY_REGEX = /^[a-zA-ZÀ-ÿ\s-']+$/;
export const ALPHANUMERIC_REGEX = /^[a-zA-Z0-9\s]+$/;
export const NUMERIC_ONLY_REGEX = /^\d+$/;

// Whitespace and length patterns
export const NO_LEADING_TRAILING_SPACES_REGEX = /^(?!\s).*(?<!\s)$/;
export const MIN_ONE_CHAR_NO_SPACES_REGEX = /^[^\s]+$/;

// Special character patterns
export const NO_SPECIAL_CHARS_REGEX = /^[a-zA-Z0-9\s]+$/;
export const HAS_UPPERCASE_REGEX = /[A-Z]/;
export const HAS_LOWERCASE_REGEX = /[a-z]/;
export const HAS_NUMBER_REGEX = /[0-9]/;
export const HAS_SPECIAL_CHAR_REGEX = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

// Currency symbols (to exclude from passwords)
export const CURRENCY_SYMBOLS_REGEX = /[€$£¥₽₹¢₿]/;

// Invoice-specific patterns
/**
 * VAT number validation (International format)
 * Format: Alphanumeric characters (letters and numbers)
 * Maximum length: 15 characters (covers most international VAT formats)
 */
export const VAT_NUMBER_REGEX = /^[A-Z0-9]{1,15}$/i;

/**
 * Italian Fiscal Code validation patterns
 * - 16 characters for individuals (alphanumeric with specific format)
 * - 11 digits for companies
 */
export const FISCAL_CODE_REGEX = /^([A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1})$|([0-9]{11})$/i;

/**
 * Italian SDI (Sistema di Interscambio) code
 * - 7 alphanumeric characters
 */
export const SDI_CODE_REGEX = /^[A-Z0-9]{7}$/i;
